import {
    UserCheck, MessageSquare, Bell, LayoutGrid, Target, BarChart3,
    Sparkles, Users, Building2, Crown, CheckCircle, Send, Zap,
    Smartphone, Award, TrendingUp, Globe, DollarSign, Heart, Shield,
    Clock, Mail, Phone, MapPin, Quote, Star, Play, ArrowRight,
    Calendar, X, Loader, Check, ChevronRight, MessageCircle,
    Bookmark, Share2, ThumbsUp, Image, ArrowLeft, Tag, User,
    HelpCircle, Percent, Gem, Church, Zap as ZapIcon
} from 'lucide-react';

const iconMap = {
    'UserCheck': UserCheck,
    'MessageSquare': MessageSquare,
    'Bell': Bell,
    'LayoutGrid': LayoutGrid,
    'Target': Target,
    'BarChart3': BarChart3,
    'Sparkles': Sparkles,
    'Users': Users,
    'Building2': Building2,
    'Crown': Crown,
    'CheckCircle': CheckCircle,
    'Send': Send,
    'Zap': Zap,
    'Smartphone': Smartphone,
    'Award': Award,
    'TrendingUp': TrendingUp,
    'Globe': Globe,
    'DollarSign': DollarSign,
    'Heart': Heart,
    'Shield': Shield,
    'Clock': Clock,
    'Mail': Mail,
    'Phone': Phone,
    'MapPin': MapPin,
    'Quote': Quote,
    'Star': Star,
    'Play': Play,
    'ArrowRight': ArrowRight,
    'Calendar': Calendar,
    'X': X,
    'Loader': Loader,
    'Check': Check,
    'ChevronRight': ChevronRight,
    'MessageCircle': MessageCircle,
    'Bookmark': Bookmark,
    'Share2': Share2,
    'ThumbsUp': ThumbsUp,
    'Image': Image,
    'ArrowLeft': ArrowLeft,
    'Tag': Tag,
    'User': User,
    'HelpCircle': HelpCircle,
    'Percent': Percent,
    'Gem': Gem,
    'Church': Church,
};

export const getIconComponent = (iconName) => iconMap[iconName] || null;